export const CITY_PROPS = [
  'ENV_CloudFountain_A.glb', 'ENV_MarketStall_A.glb', 'ENV_VillageBanner_A.glb',
  'ENV_LanternPost_A.glb', 'ENV_GoldPile_A.glb', 'ENV_SpiritWoodBundle_A.glb',
  'ENV_SkyDewJar_A.glb', 'ENV_TrainingDummy_A.glb', 'ENV_ForgeAnvil_A.glb',
  'ENV_Barrel_A.glb', 'ENV_SupplyCrate_A.glb', 'ENV_HandCart_A.glb',
  'ENV_SmallShrine_A.glb', 'ENV_GuardianStatue_A.glb', 'ENV_SpikeTrap_A.glb',
  'ENV_BombTrap_A.glb', 'ENV_TeleportPortal_A.glb', 'ENV_RewardAltar_A.glb',
  'ENV_SpiritCrystalNode_LOD0.glb', 'ENV_SpiritSupplyChest_LOD0.glb',
  'sky-lantern-post.glb', 'lotus-market-cart.glb', 'cloud-kitchen-cauldron.glb',
  'windmill-rotor.glb', 'prayer-bell-cluster.glb', 'bridge-rope-anchor.glb',
  'archery-training-target.glb', 'crystal-garden-cluster.glb', 'cloudfish-fountain.glb',
  'treasure-urn.glb', 'repair-toolbox.glb', 'tactical-map-table.glb',
  'spirit-beehive.glb', 'festival-drum.glb'
];

export const BIOMES = [
  {
    name: 'Sky Village',
    modules: ['ENV_CloudstoneBoulder_A.glb', 'ENV_LotusPondPatch_A.glb', 'ENV_PlazaTile_A.glb', 'ENV_PathStraight_A.glb', 'ENV_PathCorner_A.glb', 'ENV_PathTJunction_A.glb', 'ENV_PathCross_A.glb', 'ENV_StoneStairs_A.glb']
  },
  {
    name: 'Mistwood Ruins',
    modules: ['ENV_MistwoodDeadTree_A.glb', 'ENV_MistwoodRuinPillar_A.glb', 'ENV_MistwoodRuinArch_A.glb', 'ENV_CliffArch_A.glb', 'ENV_CliffInnerCorner_A.glb', 'ENV_WoodenBridge_A.glb']
  },
  {
    name: 'Storm Citadel',
    modules: ['ENV_StormCrystalSpire_A.glb', 'ENV_StormLightningRod_A.glb', 'ENV_CliffStraight_A.glb', 'ENV_CliffOuterCorner_A.glb', 'ENV_WallStraight_L1.glb', 'ENV_WallCorner_L1.glb', 'ENV_WallEnd_L1.glb', 'ENV_WallTJunction_L1.glb', 'ENV_WallCross_L1.glb', 'ENV_Gate_L1.glb']
  },
  {
    name: 'Volcanic Crystal Isle',
    modules: ['ENV_VolcanicLavaCrystal_A.glb', 'ENV_VolcanicVent_A.glb', 'ENV_CliffRamp_A.glb', 'ENV_WallBroken_L1.glb', 'ENV_RopeBridge_A.glb', 'ENV_StoneBridge_A.glb']
  }
];

export const MONSTERS = [
  'MON_CloudSlime_LOD0.glb', 'MON_CrystalGolem_LOD0.glb', 'MON_ThunderBird_LOD0.glb',
  'MON_FireImp_LOD0.glb', 'MON_ForestTroll_LOD0.glb', 'MON_CrystalDragon_LOD0.glb'
];

export const EQUIPMENT = [
  ['weapon', 'WPN_Dagger_LOD0.glb'], ['weapon', 'WPN_Sword_LOD0.glb'],
  ['weapon', 'WPN_Axe_LOD0.glb'], ['weapon', 'WPN_Bow_LOD0.glb'],
  ['weapon', 'WPN_Hammer_LOD0.glb'], ['weapon', 'WPN_MagicStaff_LOD0.glb'],
  ['weapon', 'WPN_SpiritBlade_LOD0.glb'], ['weapon', 'WPN_Crossbow_LOD0.glb'],
  ['armor', 'ARM_Shield_LOD0.glb'], ['armor', 'ARM_Chest_LOD0.glb'],
  ['armor', 'ARM_Helmet_LOD0.glb'], ['armor', 'ARM_Boots_LOD0.glb'],
  ['item', 'skyglass-sabre.glb'], ['item', 'thunder-war-fan.glb'],
  ['item', 'lotus-spirit-censer.glb'], ['item', 'cloudwood-longbow.glb'],
  ['item', 'storm-chakram.glb'], ['item', 'dew-pearl-wand.glb'],
  ['item', 'lion-guard-shield.glb'], ['item', 'ember-glaive.glb'],
  ['item', 'mist-lantern-staff.glb'], ['item', 'windrunner-boots.glb'],
  ['item', 'spirit-compass.glb'], ['item', 'cloudforge-helmet.glb']
];

export const PROJECTILES = [
  'PRJ_Arrow_A.glb', 'PRJ_CrossbowBolt_A.glb', 'PRJ_MagicOrb_A.glb', 'PRJ_Fireball_A.glb',
  'PRJ_LightningBolt_A.glb', 'PRJ_HealingLotus_A.glb', 'PRJ_Bomb_A.glb', 'PRJ_CrystalShard_A.glb'
];
